import { EXTRA_TIME_REQUIREMENT } from '@/types/state/book';
import { userAboutEditableFields, userAboutSchema, userContactEditableFields, userContactSchema } from '@/types/user';
import { z } from 'zod';

export const updateProfileRequestSchema = z.object({
  about: userAboutEditableFields.optional(),
  contact: userContactEditableFields.optional(),
});

export type UpdateProfileRequest = z.infer<typeof updateProfileRequestSchema>;

export const updateProfileResponseSchema = z.object({
  about: userAboutSchema,
  contact: userContactSchema,
});

export type UpdateProfileResponse = z.infer<typeof updateProfileResponseSchema>;

export const updateExtraTimeRequestSchema = z.object({
  extraTimeRequirement: z.union([
    z.literal(EXTRA_TIME_REQUIREMENT.NoExtraTime),
    z.literal(EXTRA_TIME_REQUIREMENT.NeedsExtraTime),
  ]),
  placeId: z.number(),
});

export type UpdateExtraTimeRequest = z.infer<typeof updateExtraTimeRequestSchema>;

export const updateExtraTimeResponseSchema = z.object({
  user: z.object({
    about: userAboutSchema,
    contact: userContactSchema,
  }),
  success: z.boolean(),
});

export type UpdateExtraTimeResponse = z.infer<typeof updateExtraTimeResponseSchema>;
